import React, { ReactNode } from 'react'
import Carousel from 'react-multi-carousel'
import '../Multicarousal/Multicarousal.style.css'
import 'react-multi-carousel/lib/styles.css'
interface MultiCarousalProps {
  children: ReactNode
  speed?: number
  section?: string
}

const MultiCarousal: React.FC<MultiCarousalProps> = ({
  children,
  ...props
}) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1500 },
      items: 4,
      slidesToSlide: 1,
    },
    small: {
      breakpoint: { max: 1500, min: 768 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 768, min: 576 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  }
  return (
    <div className="w-100">
      <div className="">
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          arrows={true}
          swipeable={true}
          draggable={true}
          showDots={false}
          infinite={true}
          rtl={false}
          autoPlay={true}
          //   customLeftArrow={false}
          //   customRightArrow={false}
          pauseOnHover
          autoPlaySpeed={props.speed ?? 4000}
          slidesToSlide={1}
          keyBoardControl={true}
          customTransition="transform 1500ms ease-in-out"
          transitionDuration={500}
          containerClass="carousel-container multi "
          dotListClass="custom-dot-list-style"
          itemClass="d-flex align-items-center justify-content-center px-1"
          itemAriaLabel={props.section}
          customLeftArrow={undefined}
          customRightArrow={undefined}
        >
          {children}
        </Carousel>
      </div>
    </div>
  )
}

export default MultiCarousal
